/**
 * Single source of truth for localStorage keys.
 * Use these constants everywhere; change a key only here.
 */

export const STORAGE_FOLDERS = 'buntu_custom_folders';
export const STORAGE_COLLECTIONS = 'buntu_custom_collections';
export const STORAGE_BASELINE_DEPLOYMENTS = 'uem_baseline_deployments';
export const STORAGE_POLICY_LIBRARY = 'buntu_policy_library';
export const STORAGE_CUSTOM_REPORTS = 'buntu_custom_reports';
export const STORAGE_APPLICATIONS = 'uem_applications';
export const STORAGE_APP_DEPLOYMENTS = 'uem_app_deployments';
export const STORAGE_BUNTU = 'buntu_companion';
